import React from 'react'
import { useLocalStorage } from 'react-use'
import { useConfirmDialog, useHistory } from '@ztechapps/common.hook'
import { routesDef } from '../../config/routes'
import { storageKeys } from '../../config/StorageKeys'
import { useActiveQuotation } from '../../hooks/useActiveQuotation'

//shown once per login (flag in localStorage, cleared on logout); renders nothing itself
export const OrderAlertDialog = () => {
  const { loggedIn, hasActiveQuotation, latestQuotationId } = useActiveQuotation()
  const history = useHistory()
  const [shown, setShown] = useLocalStorage(storageKeys.orderAlertDialogShown, false)

  const { confirm } = useConfirmDialog({
    title: 'Active Quotation',
    text: 'Your quotation is ready for you. Finish it to move your order forward — or, if it is outdated or no longer needed, open it and cancel it.',
    icon: 'warning',
    dangerMode: false,
    buttons: { cancel: 'Dismiss', confirm: { text: 'View Quotation' } },
  })

  React.useEffect(() => {
    if (!loggedIn || !hasActiveQuotation || shown) return
    //mark shown before opening so navigation/reload within this login won't reopen it
    setShown(true)
    //fires only once a quotation exists, so latestQuotationId is set — deep-link to its detail page
    const quotationTo = latestQuotationId
      ? routesDef.AccountOrderItem.altPath({ _id: latestQuotationId })
      : routesDef.AccountOrders.altPath({ activeTab: 'quotation' })
    confirm(
      async () => history.push(quotationTo),
      async () => undefined
    )
  }, [loggedIn, hasActiveQuotation, shown, latestQuotationId, confirm, history, setShown])

  return null
}
